import React from "react";
import { IconButton } from "@mui/material";
import EditOutlined from "@mui/icons-material/EditOutlined";

import { type CartonPropertyGroup, type CartonPropertyGroupConfiguration } from "@/schemas";
import { useUpdateCartonPropertyGroup } from "@/hooks/carton-property-groups/use-update-carton-property-group";

import { CartonPropertyGroupsConfigurationModal } from "../carton-property-groups-configuration-modal";

interface CartonPropertyGroupEditButtonProps {
	readonly cartonPropertyGroup: CartonPropertyGroup;
}

export const CartonPropertyGroupEditButton: React.FC<CartonPropertyGroupEditButtonProps> = ({
	cartonPropertyGroup,
}) => {
	const [showEdit, setShowEdit] = React.useState(false);
	const { mutateAsync: updateCartonPropertyGroupAsync, error } = useUpdateCartonPropertyGroup();

	const handleSubmit = async (data: CartonPropertyGroupConfiguration): Promise<void> => {
		try {
			await updateCartonPropertyGroupAsync({
				cartonPropertyGroupId: cartonPropertyGroup.id,
				data: { ...cartonPropertyGroup, ...data },
			});
			setShowEdit(false);
		} catch {
			/* Handled */
		}
	};

	const defaultValues: CartonPropertyGroupConfiguration = {
		alias: cartonPropertyGroup.alias,
		ratio: cartonPropertyGroup.ratio,
		assignedToProductionGroups: cartonPropertyGroup.assignedToProductionGroups,
	};

	return (
		<>
			<CartonPropertyGroupsConfigurationModal
				open={showEdit}
				onClose={() => setShowEdit(false)}
				onSubmit={handleSubmit}
				error={error}
				defaultValues={defaultValues}
			/>
			<IconButton
				onClick={() => setShowEdit(true)}
				data-testid="carton-property-group-edit-button__button__open-modal"
				data-pendoid="carton-property-groups__button__edit"
			>
				<EditOutlined />
			</IconButton>
		</>
	);
};
